<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router'

withDefaults(
  defineProps<{
    to?: RouteLocationRaw
    variant?: 'default' | 'pdf'
  }>(),
  {
    variant: 'default',
  },
)
</script>

<template>
  <div class="cta" :class="`cta--${variant}`">
    <div class="cta__inner">
      <h4 v-if="$slots.title" class="cta__title">
        <slot name="title" />
      </h4>

      <div v-if="$slots.description" class="cta__text">
        <slot name="description" />
      </div>

      <router-link
        v-if="$slots.button"
        :to="to ?? { name: 'signup' }"
        class="button button--theme button--size-m cta__button"
      >
        <slot name="button">Sign up for free</slot>
      </router-link>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.cta {
  border-radius: 12px;
  border: 1px solid $c-theme;
  background: $c-light-yellow;
  width: 100%;
  padding: 40px 60px;
  text-align: center;

  @media only screen and (max-width: $sm) {
    padding: 40px 30px;
  }

  &--pdf {
    text-align: left;
    display: block;
  }

  &__title {
    font-size: 24px;
    line-height: 28px;
    margin-bottom: 12px;
  }

  &__text {
    color: $c;
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 20px;
  }

  &__button {
    font-size: 16px;
    line-height: 18px;
  }
}
</style>
